import { render } from "./SetorView.vue?vue&type=template&id=3dd66666"
import script from "./SetorView.vue?vue&type=script&lang=js"
export * from "./SetorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__